import { getAuth, signInWithPopup, GoogleAuthProvider } from "@firebase/auth";
import { useEffect } from "react";
import GoogleButton from "react-google-button";
import { useNavigate } from "react-router-dom";

const provider = new GoogleAuthProvider();

const Login = ({ user, setUser }) => {
  let navigate = useNavigate();
  const handleLogin = () => {
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then((result) => {
        setUser(result.user);
      })
      .catch((err) => err.message);
  };

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user]);

  return (
    <div className="home">
      <h2>Your motivation for today!</h2>
      <p> "Nothing is impossible. The word itself says I'm possible!" </p>
      <p>{"Welcome! Your Goals are waiting for you!"}</p>
      {/* <GoogleButton type="light" onClick={handleLogin} /> */}
    </div>
  );
};

export default Login;
